<template>
	<div class="category-item-siblings">
		<template v-if="siblings.length > 0 && allSiblingsHaveAttributeImage">
			<div
				v-if="hasCurrentVariation"
				@click="passData(currentVariation)"
				class="preview-attr"
				:class="{ isActive: currentVariation.variationId === activeId }"
				:data-hover="currentVariation.attribute.name"
			>
				<div class="attr-img-container">
					<img
						:src="currentVariation.attribute.image"
						:alt="'Preview: ' + currentVariation.variationId"
						:title="currentVariation.attribute.name"
					/>
				</div>
			</div>
			<div
				v-for="sibling in siblings"
				@click="passData(sibling)"
				class="preview-attr"
				:class="{ isActive: sibling.variationId === activeId }"
				:data-hover="sibling.attribute.name"
			>
				<div class="attr-img-container">
					<img
						:src="sibling.attribute.image"
						:alt="'Preview: ' + sibling.variationId"
						:title="sibling.attribute.name"
					/>
				</div>
			</div>
			<div v-if="moreSiblingsCount > 0" class="more-colors">
				<a v-if="variationLink !== ''" :href="variationLink"> +{{ moreSiblingsCount }} </a>
				<template v-else> +{{ moreSiblingsCount }} </template>
			</div>
		</template>
		<template v-else>
			<div v-if="isCatItemSiblingsLoading" class="skeleton-icon-wrapper">
				<div class="skeleton-variation-icon skeleton-shimmer"></div>
				<div class="skeleton-variation-icon skeleton-shimmer"></div>
				<div class="skeleton-variation-icon skeleton-shimmer"></div>
			</div>
			<div v-else-if="catItemSiblingsIsDirty" class="skeleton-icon-wrapper"></div>
		</template>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	props: {
		itemId: {
			type: Number,
			required: true
		},
		variationId: {
			type: Number,
			required: true
		},
		variationLink: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			activeId: 0
		};
	},

	computed: {
		currentVariation() {
			if (this.itemId in this.categoryItemSiblings) {
				let currentVariation = this.categoryItemSiblings[this.itemId].filter((variation) => {
					return variation.variationId === this.variationId;
				});

				if (currentVariation.length === 1) return currentVariation[0];
			}
			return {};
		},

		hasCurrentVariation() {
			return Object.keys(this.currentVariation).length > 0;
		},

		siblings() {
			if (this.itemId in this.categoryItemSiblings) {
				let siblings = this.categoryItemSiblings[this.itemId].filter((variation) => {
					return variation.variationId !== this.variationId;
				});

				if (siblings.length <= 1) return siblings;

				return this.orderByOption(siblings).slice(0, App.Eros.Config.itemlists.categoryItemSiblingsLimit);
			}
			return [];
		},

		moreSiblingsCount() {
			return this.siblings.length > 0
				? this.categoryItemSiblings[this.itemId].length -
						this.siblings.length -
						(this.hasCurrentVariation ? 1 : 0)
				: 0;
		},

		allSiblingsHaveAttributeImage() {
			return (
				this.siblings.filter((sibling) => {
					return sibling.attribute.image !== "";
				}).length === this.siblings.length
			);
		},

		...mapState({
			categoryItemSiblings: (state) => state.CategoryItemSiblings.categoryItemSiblings,
			isCatItemSiblingsLoading: (state) => state.CategoryItemSiblings.categoryItemSiblingsIsLoading,
			catItemSiblingsIsDirty: (state) => state.CategoryItemSiblings.categoryItemSiblingsIsDirty
		})
	},

	created() {
		this.activeId = this.variationId;
	},

	methods: {
		orderByOption: function (relay) {
			if (App.Eros.Config.itemlists.categoryItemSiblingsOrder === "Position") {
				if (typeof relay[0].position != "undefined") {
					if (relay[0].position !== null) {
						relay.sort(function (aa, bb) {
							if (aa.position && bb.position) {
								return aa.position > bb.position ? -1 : bb.position > aa.position ? 1 : 0;
							} else if (aa.position) {
								return -1;
							} else if (bb.position) {
								return 1;
							} else {
								return 0;
							}
						});
					}
				}
			} else if (typeof relay[0].attribute.valueId != "undefined") {
				if (relay[0].attribute.valueId !== null) {
					relay.sort(function (aa, bb) {
						if (aa.attribute?.valueId && bb.attribute?.valueId) {
							return aa.attribute.valueId > bb.attribute.valueId ? 1 : bb.attribute.valueId > aa.attribute.valueId ? -1 : 0;
						} else if (aa.attribute?.valueId) {
							return -1;
						} else if (bb.attribute?.valueId) {
							return 1;
						} else {
							return 0;
						}
					});
				}
			}

			return relay;
		},
		passData: function (relay) {
			this.activeId = relay.variationId;
			this.$emit("changeVariation", relay);
		}
	}
};
</script>